"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteOfferItemHandler = deleteOfferItemHandler;
var _deleteOfferItemFailed = require("@ori-events/delete-offer-item-failed");
var _api = require("../api");
var _logger = require("../logger");
const dispatchErrorEvent = detail => {
  const errorEvent = new CustomEvent(_deleteOfferItemFailed.Name, {
    detail
  });
  window.dispatchEvent(errorEvent);
};
async function deleteOfferItemHandler({
  detail: {
    choiceId,
    itemCode
  }
}, {
  client,
  sessionId,
  tenant
}) {
  // STEP 1 - Update through API
  try {
    await (0, _api.deleteOfferItem)({
      client,
      itemCode,
      offerId: choiceId,
      sessionId,
      tenant
    });
  } catch (error) {
    _logger.mainLogger.error(error, {
      message: 'Error while deleting offer item in delete-offer-item event.'
    });
    dispatchErrorEvent({
      isSuccess: false,
      localizedMessage: '',
      message: 'Deletion of offer item failed via API call'
    });
    return false;
  }

  // STEP 2 - Update shopping context via Online endpoint
  const data = await (0, _api.fetchShoppingContextData)();
  if ((0, _deleteOfferItemFailed.isDeleteOfferItemErrorResponse)(data)) {
    dispatchErrorEvent(data);
    return false;
  }
  return data;
}
